module.exports = __webpack_public_path__ + "img/allGames.6ba9998f.svg";